export const CANCEL_APPOINTMENT = "CANCEL_APPOINTMENT"
export const CANCEL_APPOINTMENT_FAIL = "CANCEL_APPOINTMENT_FAIL"
export const CANCEL_APPOINTMENT_SUCCESS = "CANCEL_APPOINTMENT_SUCCESS"
export const CANCEL_APPOINTMENT_RESET = "CANCEL_APPOINTMENT_RESET"

export const cancelAppointment = (params) => {
    return { type: CANCEL_APPOINTMENT, params }
}
export const cancelAppointmentFail = (response) => {
    return { type: CANCEL_APPOINTMENT_FAIL, response }
}
export const cancelAppointmentSuccess = (response) => {
    return { type: CANCEL_APPOINTMENT_SUCCESS, response }
}
export const cancelAppointmentReset = () => {
    return { type: CANCEL_APPOINTMENT_RESET }
}